import React, { useState, useEffect } from 'react';
import './index.scss';
import Gallery from "../../components/templates/gallery/Gallery";
import GalleryService from "../../shared/services/GalleryService";
import PSLoading from "../../components/PSLoading";
import {GalleryModel} from "../../shared/model/GalleryModel";

const photos = [
  { name:'Lorem ipsum dolor sit amet.',  date: '10.05.2021', status:'Publicado'},
  { name:'Lorem ipsum dolor sit amet.', date: '10.05.2021', status:'Publicado'},
  { name:'Lorem ipsum dolor sit amet.', date: '10.05.2021', status:'Publicado'},
  { name:'Lorem ipsum dolor sit amet.',  date: '10.05.2021', status:'Publicado'},
  { name:'Lorem ipsum dolor sit amet.', date: '10.05.2021', status:'Publicado'},
  { name:'Lorem ipsum dolor sit amet.', date: '10.05.2021', status:'Publicado'},
  { name:'Lorem ipsum dolor sit amet.',  date: '10.05.2021', status:'Publicado'},
  { name:'Lorem ipsum dolor sit amet.', date: '10.05.2021', status:'Publicado'},
  { name:'Lorem ipsum dolor sit amet.', date: '10.05.2021', status:'Publicado'}

];
export default function GalleryPage() {

  const [showModalNewPhoto, setShowModalNewPhoto] = useState(false);
  const [listGallery, setListGallery] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingSave, setLoadingSave] = useState(false);

  const [currentPhoto, setCurrentPhoto] = useState(null);
  const [newPhoto, setNewPhoto] = useState({
    idSection:'1',
    description:'',
    photo:null

  });

  const onChangePhoto = (property,value)=>{
    newPhoto[property]=value;
    setNewPhoto({...newPhoto});
  };

  const loadGallery = async () => {
    try{
     const response  = await GalleryService.responseGetGallery();

      const gallery = response.data.map((data) => new GalleryModel(data));
      setListGallery([...gallery]);
      setLoading(false);
    }catch (error){
      setLoading(false);
    }
  };

  const saveGallery = async () => {
    try{
      let formData = new FormData();
      formData.append('idSection', newPhoto.idSection);
      formData.append('description', newPhoto.description);
      formData.append('photo',newPhoto.photo);
      setLoadingSave(true);
      await GalleryService.responseSavePhoto(formData);
      setLoadingSave(false);
      setShowModalNewPhoto(false);
      await loadGallery();

    }catch (error){

    }
  };

  const deleteGallery = async (id) => {
    try {
      await GalleryService.responseDeletePhoto(id)
      const filterGallery = listGallery.filter(item => item.id !== id)
      setListGallery([...filterGallery]);
    }catch(error){

    }
  };


  useEffect(()=>{
    loadGallery();
  },[]);

  return(
    <div>
      {
        loading ?
          <div className="d-flex-center">
            <PSLoading color="red"/>
          </div>:
          <Gallery
            items ={listGallery}
            currentPhoto={currentPhoto}
            onChangePhoto={onChangePhoto}
            showModalNewPhoto={showModalNewPhoto}
            onCreateNewPhoto = {()=>setShowModalNewPhoto(true)}
            onCloseModal = {()=>setShowModalNewPhoto(false)}
            saveGallery={saveGallery}
            loadingSave={loadingSave}
            deleteGallery={deleteGallery}
            onSelectGallery = {(data)=> {setCurrentPhoto(data)}}
          />
      }
    </div>
  )
}